import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './NewHrUploadFolder.css';

const NEW_HR_ROOT =
  process.env.REACT_APP_NEW_HR_BASE ||
  process.env.REACT_APP_HR_BASE ||
  '/new-hr';

function NewHrUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={NEW_HR_ROOT}
      sessionPrefix="new_hr_folder"
    />
  );
}

NewHrUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default NewHrUploadFolder;
